import { NotificationType, NotificationTypeOption } from "../types/notificationTypes";

export const isOnFailureNotificationType = (type: NotificationType | NotificationTypeOption): boolean => {
    if (typeof type === 'object' && type !== null) {
      return type.value === NotificationType.OnFailure;
    }
    return type === NotificationType.OnFailure;
  };